class SectionTwotier extends HTMLElement {
  constructor() {
    super();
    this.tabheading = this.querySelectorAll('.tabheading_btn');
    this.tabdetails = this.querySelectorAll('.sec-Section_Inner__soh');
    this.enableSlider = this.getAttribute('data-slider');

    if (!this.tabheading.length) return; // Ensure there are tabs

    this.init();
  }

  init() {
    this.tabheading.forEach((tab, i) => {
      const tabContentId = tab.getAttribute('data-id');
      const tabContentEle = this.querySelector(`#${tabContentId}`);
      const tabContentEleSlider = tabContentEle?.querySelector('.slider-flickity');
      if(this.enableSlider != 'false'){
        if (tabContentEleSlider && !tabContentEleSlider.classList.contains('flickity-enabled')) {
          this.initializeFlickity(tabContentEleSlider);
        }
      }
      tab.addEventListener("click", (e) => this.onTabClick(e, tabContentEle, tabContentEleSlider));
      this.initializeTabSlides(tabContentEle);
    });
  }

  initializeFlickity(sliderElement) {
    const options = JSON.parse(sliderElement.getAttribute('data-option'));
    const flickityInstance = new Flickity(sliderElement, options);
    setTimeout(() => flickityInstance.resize(), 1000);
    window.addEventListener('resize', function() {flickityInstance.resize()});
  }

  onTabClick(event, tabContentEle, tabContentEleSlider) {
    this.tabheading.forEach(item => item.classList.remove('active'));
    this.tabdetails.forEach(item => item.style.display = "none");
    event.currentTarget.classList.add('active');
    tabContentEle.style.display = "block";
    if(this.enableSlider != 'false'){
      if (tabContentEleSlider && !tabContentEleSlider.classList.contains('flickity-enabled')) {
        this.initializeFlickity(tabContentEleSlider);
      } else if (tabContentEleSlider) {
        const flkty = Flickity.data(tabContentEleSlider);
        if (flkty) {
          flkty.resize();
          setTimeout(() => flkty.resize(), 1000);
        }
      }
    }
  }

  initializeTabSlides(tabContentEle) {
    const tabSlides = tabContentEle.querySelectorAll('.sohSlide');
    tabSlides.forEach((item) => {
      const index = item.getAttribute('data-index');
      const promotion = item.getAttribute('data-promotion');
      const name = item.querySelector('h3').textContent;
      item.addEventListener("click", () => this.onSlideClick(promotion, name, index));
      observerIns.observe(item);
    });
    tabContentEle.querySelectorAll("card-colours").forEach(function (item) {
      generateSwatches(item);
    });
  }

  onSlideClick(promotion, name, index) {
    setSelectPromotion(promotion, name, index);
  }
}

customElements.define('section-twotier', SectionTwotier);